import { render, staticRenderFns } from "./SingleProject.vue?vue&type=template&id=26b02353&"
import script from "./SingleProject.vue?vue&type=script&lang=ts&"
export * from "./SingleProject.vue?vue&type=script&lang=ts&"
import style0 from "./SingleProject.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports